import { ActionTypeModel } from '../../../shared';
export const actionMessages = new Map([[ActionTypeModel.ACCEPT_MEMBERSHIP_BANNER_ACTION, {
  detail: 'UI-LIB.BANNER.ACTION_REQUIRED.TEXT',
  buttonText: 'UI-LIB.BANNER.ACTION_REQUIRED.MOVE_TO_PROFILE'
}], [ActionTypeModel.RELOAD_PAGE_BANNER_ACTION, {
  detail: 'UI-LIB.BANNER.ACTION_REQUIRED.RELOAD_TEXT',
  buttonText: 'UI-LIB.BANNER.ACTION_REQUIRED.RELOAD_BTN_TEXT'
}]]);
